
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";

import { getExamSyllabusList, generatePaperV1Svc, getSyllabusDropdownSvc, getSubjectListV1Svc, getGeneratedQpSvc } from './questionPaperSvc';
import ExamHeader from './examHeader';
import QuestionPaperTbl from './questionPaperTable';
import ExamPatternSlider from './questionPaperPatternSlider';
import QuestionPaperPdfSlider from '../questionPaperPdf/questionPaperPdfSlider';
import SyllabusClasses from './syllabusClasses';

function QuestionPaperCtrl() {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstSyllabus, setLstSyllabus] = useState([]);
    const [lstSyllabusSelect, setLstSyllabusSelect] = useState([]);
    const [examId, setExamId] = useState(0);
    const [flgPatternSliderVisible, setFlgPatternSliderVisible] = useState(false);
    const [exam, setExam] = useState({});
    const [examName, setExamName] = useState("");
    const [syllabusObj, setSyllabusObj] = useState("");
    const [key, setKey] = useState(0);
    const [syllabusId, setSyllabusId] = useState(0);
    const [clsId, setClsId] = useState(0);
    const [subjectId, setSubjectId] = useState(0);
    const [isPdfSliderVisible, setIsPdfSliderVisible] = useState(false);
    const [examDuration, setExamDuration] = useState(0);
    const [examMaxMarks, setExamMarks] = useState(0);
    const [examSubject, setExamSubject] = useState("");
    const [lstSubject, setLstSubject] = useState([]);
    // Generate ke response � subjectId ke hisaab se alag-alag store karte hain, taaki
    // multiple subjects generate karne ke baad har row ka apna "View PDF" usi ka data dikhaye
    // { subjectId: [ {setNo, ...}, ... ] }
    const [generatedSetsBySubject, setGeneratedSetsBySubject] = useState({});

    useEffect(() => {
        // console.log("examPatternCtrl called");
        if (examId)
            getSyllabusList(examId);
    }, [key]);

    useEffect(() => {
        // console.log("subject list effect called, examId", examId, ", syllabusId", syllabusId);
        // key included so updateKey() (called after Save/apply pattern) also refreshes this grid �
        // previously only the syllabus dropdown refreshed on save, so the grid kept showing the
        // stale patternId, making "Generate" wrongly say "please apply a pattern first".
        if (examId && syllabusId)
            getSubjectList(examId, syllabusId);
    }, [examId, syllabusId, key]);

    const getSubjectList = (pExamId, pSyllabusId) => {
        setLoader("block");
        setOpacity(0.5);
        getSubjectListV1Svc(pExamId, pSyllabusId, subjectListResponse);
    }

    const subjectListResponse = (data) => {
        // console.log("subjectListResponse called, data", data);
        if (data.status === "Success") {
            setLstSubject(data.lstSubject);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }


    const changeExam = (pExam) => {
        // console.log("changeExam called, pExam", pExam);
        setExam(pExam);
        setExamId(pExam.examId);
        setExamName(pExam.exam);
        getSyllabusList(pExam.examId);
    }

    const getSyllabusList = (pExamId) => {
        // console.log("getSyllabusList called, pExamId", pExamId);
        setLoader("block");
        setOpacity(0.5);
        getExamSyllabusList(pExamId, syllabusListResponse);
    }

    const syllabusListResponse = (data) => {
        // console.log("syllabusListResponse called, data", data);
        if (data.status === "Success") {
            setLstSyllabus(data.lstSyllabus);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const handleSyllabusChange = (pSyllabusId) => {
        // console.log("handleSyllabusChange called, pSyllabusId", pSyllabusId);
        setSyllabusId(pSyllabusId);
    }

    const handleClassChange = (pClsId) => {
        // console.log("handleClassChange called, pClsId", pClsId);
        setClsId(pClsId);
    }

    const openPatternSlider = () => {
        // console.log("openPatternSlider called");
        setFlgPatternSliderVisible(true);
    }

    const closePatternSlider = () => {
        // console.log("closePatternSlider called");
        setFlgPatternSliderVisible(false);
    }

    const editExamPattern = async (pSyllabus) => {
        // console.log("editExamPattern called pSyllaubs", pSyllabus);
        await setSyllabusId(pSyllabus.syllabusId);
        await setSyllabusObj(pSyllabus);
        openPatternSlider();
    }

    // "16-07-2026 12:36:47" jaisa format � backend jo actual save karta hai wahi shape,
    // taaki grid ka "Generated On" turant (refresh ke bina) update dikhe.
    const formatNowDttm = () => {
        const d = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        return pad(d.getDate()) + "-" + pad(d.getMonth() + 1) + "-" + d.getFullYear() + " " +
            pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
    }

    // Generate success hone ke turant baad grid ke us subject ki row ka "Generated On" update karo
    const markSubjectGenerated = (pSubjectId) => {
        setLstSubject((prev) => prev.map((sub) =>
            sub.subjectId === pSubjectId ? { ...sub, qpGeneratedDttm: formatNowDttm() } : sub
        ));
    }

    // Core reusable logic � ek subject ke N sets sequentially generate karta hai.
    // Success pe collected array return karta hai, fail pe null (error toast khud dikha deta hai).
    const generateSetsForSubject = async (pSubjectId, pPatternId, pSetCount) => {
        const totalSets = Number(pSetCount) > 0 ? Number(pSetCount) : 1;
        const collected = [];
        for (let setNo = 1; setNo <= totalSets; setNo++) {
            // console.log("generating set", setNo, "of", totalSets, "for subject", pSubjectId);
            const data = await generateOneSet(pPatternId, pSubjectId);
            if (data.status !== "Success") {
                if (data.status === "Failure") {
                    handleServiceError(data.message);
                } else {
                    toast.error("Service failed " + data.error);
                }
                return null; // ek set fail hua to yahin ruk jao, incomplete paper mat dikhao
            }
            collected.push({ setNo, ...data.data });
        }
        return collected;
    }

    const generateExamPatternSingle = async (pSubjectId, pPatternId, pSetCount) => {
        // console.log("generateExamPatternSingle called, pSubjectId", pSubjectId, ", pPatternId", pPatternId, ", pSetCount", pSetCount);
        if (!clsId) {
            toast.warn("please select a class");
            return;
        }
        if (!pPatternId) {
            toast.warn("please apply a pattern first");
            return;
        }
        setLoader("block");
        setOpacity(0.5);

        const collected = await generateSetsForSubject(pSubjectId, pPatternId, pSetCount);
        if (collected) {
            setGeneratedSetsBySubject((prev) => ({ ...prev, [pSubjectId]: collected }));
            markSubjectGenerated(pSubjectId);
            toast.success("Question paper generated (" + collected.length + (collected.length === 1 ? " set)" : " sets)"));
        }
        setLoader("none");
        setOpacity(1);
    }

    // "Generate Question Paper" (top button) � Select checkbox se chune gaye saare subjects
    // ke liye ek-ek karke generate karta hai. Jis subject pe pattern nahi laga hai use skip karta hai.
    const generateExamPatternSelected = async () => {
        // console.log("generateExamPatternSelected called, lstSyllabusSelect", lstSyllabusSelect);
        if (!clsId) {
            toast.warn("please select a class");
            return;
        }
        if (!lstSyllabusSelect || !lstSyllabusSelect.length) {
            toast.warn("please select at least one subject");
            return;
        }

        setLoader("block");
        setOpacity(0.5);

        let successCount = 0;
        let skippedCount = 0;
        const updates = {};

        for (let i = 0; i < lstSyllabusSelect.length; i++) {
            const subId = lstSyllabusSelect[i];
            const row = lstSubject.find((s) => s.subjectId === subId);
            if (!row || !row.patternId) {
                skippedCount++;
                continue; // is subject pe abhi tak pattern nahi laga � skip
            }
            const collected = await generateSetsForSubject(subId, row.patternId, row.setCount);
            if (collected) {
                updates[subId] = collected;
                markSubjectGenerated(subId);
                successCount++;
            }
        }

        if (Object.keys(updates).length) {
            setGeneratedSetsBySubject((prev) => ({ ...prev, ...updates }));
        }
        setLoader("none");
        setOpacity(1);

        if (successCount > 0) {
            toast.success(successCount + " question paper(s) generated" +
                (skippedCount ? (", " + skippedCount + " skipped (no pattern applied)") : ""));
        } else {
            toast.warn("No question papers generated � apply a pattern to selected subjects first");
        }
    }

    // Ek set generate karne ka Promise wrapper � generatePaperV1Svc callback-based hai,
    // isse await karne layak banaya taaki sequentially (ek ke baad ek) call kar sakein
    const generateOneSet = (pPatternId, pSubjectId) => {
        return new Promise((resolve) => {
            generatePaperV1Svc(pPatternId, clsId, pSubjectId, examId, syllabusId, (data) => resolve(data));
        });
    }

    const generateQuestionPaperResponse = (data) => {
        // console.log("generateQuestionPaperResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const openPdf = async (pSyllabus) => {
        // console.log("openPdf called, pSyllabus", pSyllabus);
        await setExamDuration(pSyllabus.duration);
        await setExamMarks(pSyllabus.maxMarks);
        await setExamSubject(pSyllabus.sub);
        await setSubjectId(pSyllabus.subId);

        // In-memory state (this browser session) already has it � no need to fetch.
        if (generatedSetsBySubject[pSyllabus.subId] && generatedSetsBySubject[pSyllabus.subId].length) {
            setIsPdfSliderVisible(true);
            return;
        }

        // Nothing in memory (page was refreshed, or generated in an earlier session) �
        // fetch the previously generated paper(s) back from the question_paper table.
        if (!pSyllabus.patternId) {
            toast.warn("Please generate the question paper first");
            return;
        }
        setLoader("block");
        setOpacity(0.5);
        getGeneratedQpSvc(examId, clsId, pSyllabus.subId, pSyllabus.patternId, pSyllabus.noOfSets, (data) => {
            setLoader("none");
            setOpacity(1);
            if (data.status === "Success") {
                setGeneratedSetsBySubject((prev) => ({ ...prev, [pSyllabus.subId]: data.lstSet }));
                setIsPdfSliderVisible(true);
            } else if (data.status === "Failure") {
                toast.warn(data.message || "Please generate the question paper first");
            } else {
                toast.error("Service failed " + data.message);
            }
        });
    }

    const closePdf = () => {
        // console.log("closePdf called");
        setIsPdfSliderVisible(false);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }

    const lstFilteredSyllabus = syllabusId
        ? lstSyllabus.filter((row) => row.syllabusId == syllabusId)
        : lstSyllabus;

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-md-11 col-xs-11 col-centered padding-remove">
                <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
                    <ExamHeader
                        changeExam={changeExam}
                        examId={examId}
                        generateExamPattern={generateExamPatternSelected}
                    />
                </div>
                <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
                    <SyllabusClasses
                        syllabusId={syllabusId}
                        clsId={clsId}
                        handleSyllabusChange={handleSyllabusChange}
                        handleClassChange={handleClassChange}
                        setLoader={() => {}}
                        setOpacity={() => {}}
                        syllabusListSvc={getSyllabusDropdownSvc}
                    />
                </div>
                <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "80px" }}>
                    <QuestionPaperTbl
                        key={syllabusId}
                        lstSubject={lstSubject}
                        lstSyllabusSelect={lstSyllabusSelect}
                        setLstSyllabusSelect={setLstSyllabusSelect}
                        generateExamPatternSingle={generateExamPatternSingle}
                        editExamPattern={editExamPattern}
                        syllabusId={syllabusId}
                        subjectId={subjectId}
                        setSubjectId={setSubjectId}
                        openPdf={openPdf}
                    />
                </div>
            </div>
            {
                flgPatternSliderVisible ?
                    <div className="slider1-60">
                        <ExamPatternSlider
                            examId={examId}
                            exam={exam}
                            syllabusObj={syllabusObj}
                            syllabusId={syllabusId}
                            updateKey={updateKey}
                            closeSlider={closePatternSlider}
                        />
                    </div>
                    : null
            }
            {
                isPdfSliderVisible ?
                    <div className="slider1-60">
                        <QuestionPaperPdfSlider
                            examId={examId}
                            syllabusId={syllabusId}
                            subjectId={subjectId}
                            examName={examName}
                            examDuration={examDuration}
                            examMaxMarks={examMaxMarks}
                            examSubject={examSubject}
                            generatedSets={generatedSetsBySubject[subjectId] || []}
                            closeSlider={closePdf}
                        />
                    </div>
                    : null
            }
        </div >
    )
}
export default QuestionPaperCtrl;
